// Module
var code = "<branch-terms kind=\"'deliveryTerms'\"></branch-terms>\n";
// Exports
module.exports = code;